module.exports = __webpack_public_path__ + "img/tree-05-c-trunk.2fb5ce4a.png";